import { CompanyPlan } from '../../modules/data/domain/Company';

export const notUpgradableCompanyPlans = [CompanyPlan.BookkeepersAndAccountantsPackage];
